import React, { FunctionComponent } from 'react';
import { Grid, Typography } from '@material-ui/core';
import labelAndPriceStyles from './LabelAndPriceStyles';
import DotsLoader from '../../../../../../common/components/dotsLoader/DotsLoader';

export interface ILabelAndPercentageProps {
  label: string | JSX.Element;
  percentage: number;
  percentageType: string;
  loading?: boolean;
}

const LabelAndPercentage: FunctionComponent<ILabelAndPercentageProps> = ({
  label,
  percentage,
  percentageType,
  loading,
}) => {
  const styles = labelAndPriceStyles();

  return (
    <Grid container={true} justifyContent={'space-between'} spacing={3} className={styles.lineContainer}>
      <Grid item={true} sm={8} xs={6}>
        {label}
      </Grid>
      <Grid item={true} sm={4} xs={6} className={styles.priceContainer} data-test={`summary:price:${percentageType}`}>
        {loading ? (
          <DotsLoader />
        ) : (
          <Typography variant="body1" className={styles.boldLabel}>
            {percentage}%
          </Typography>
        )}
      </Grid>
    </Grid>
  );
};

export default LabelAndPercentage;
